<script>
    import { mapActions, mapState } from "vuex";
    import { FREE_DELIVERY_LIMIT } from "@/settings/constants";
    import TheSvgIcon from "@main/packages/TheSvgIcon";
    import FreeDeliveryModal from "@/components/FreeDeliveryModal";
    import HeaderCartDropdown from "@/components/header/HeaderCartDropdown";

    export default {
        name: "HeaderCart",
        components: {
            FreeDeliveryModal,
            TheSvgIcon,
            HeaderCartDropdown,
        },
        props: {
            isOrderPage: Boolean,
            cart: Object,
            freeDeliveryCount: Number,
        },
        data() {
            return {
                stateModal: false,
                isAnimatedNumber: false,
            };
        },
        computed: {
            ...mapState("Root", ["stateFreeDeliveryModal"]),
            freeDeliveryLimit() {
                return FREE_DELIVERY_LIMIT;
            },
            hasProduct() {
                return this.cart.number > 0;
            },
            resultToFreeDelivery() {
                return this.freeDeliveryCount - this.cart.totalPrice;
            },
        },
        watch: {
            stateFreeDeliveryModal: {
                handler(updatedState) {
                    this.stateModal = updatedState;
                },
            },
            "cart.number": {
                handler() {
                    this.startAnimation();
                },
            },
        },
        methods: {
            ...mapActions("Root", ["removeProductInCart"]),
            startAnimation() {
                this.isAnimatedNumber = true;
                setTimeout(() => (this.isAnimatedNumber = false), 300);
            },
            onRemoveProduct(productId) {
                this.removeProductInCart({ quantity: 0, productId });
            },
            hideModal() {
                this.stateModal = false;
            },
            goToOrder() {
                if (this.hasProduct) {
                    this.$router.push({
                        name: "Order",
                    });
                }
            },
        },
    };
</script>

<template>
    <div class="c-cart">
        <div class="c-cart__button" :class="{ 'is-disabled': isOrderPage || !hasProduct }">
            <div
                class="c-cart__line outline"
                @click="goToOrder"
                @keypress.enter="goToOrder"
                :tabindex="isOrderPage || !hasProduct ? '-1' : '0'"
            >
                <div class="c-cart__icon">
                    <div
                        v-show="hasProduct"
                        class="c-cart__icon-number"
                        :class="{ 'is-animated': isAnimatedNumber }"
                    >
                        {{ cart.number }}
                    </div>
                    <the-svg-icon name="cart" :size-w="24"></the-svg-icon>
                </div>
                <div class="c-cart__text">Корзина</div>
            </div>

            <div v-if="hasProduct && !isOrderPage" class="c-cart__dropdown mobile-hidden">
                <header-cart-dropdown
                    :cart="cart"
                    variant="v1"
                    size="md"
                    @on-remove-product="onRemoveProduct"
                ></header-cart-dropdown>
            </div>
        </div>

        <template v-if="freeDeliveryCount < freeDeliveryLimit">
            <free-delivery-modal
                v-show="stateModal"
                :result-to-free-delivery="resultToFreeDelivery"
                :button-variants="['v1', 'v3']"
                @hide-modal="hideModal"
            ></free-delivery-modal>
        </template>
    </div>
</template>

<style lang="scss">
    .c-cart__button {
        &.is-disabled {
            pointer-events: none;
        }
        @include bp($bp-desktop-sm) {
            position: relative;
            display: block;
            padding: 12px 0;
            cursor: pointer;
            &:hover,
            &:focus-within {
                .c-cart__dropdown {
                    transform: translateY(0);
                    opacity: 1;
                    visibility: visible;
                }

                .c-cart__icon {
                    svg {
                        fill: var(--primary);
                    }
                }

                .c-cart__text {
                    color: var(--primary);
                }
            }
        }
    }

    .c-cart__dropdown {
        @include bp($bp-desktop-sm) {
            position: absolute;
            z-index: 10;
            top: 50px;
            right: 0;
            width: 377px;
            opacity: 0;
            visibility: hidden;
            transform: translateY(-4px);
            transition: 0.2s ease-in-out all;
        }
    }

    .c-cart__text {
        display: none;
        @include bp($bp-desktop-sm) {
            display: block;
            margin-left: 4px;
            color: var(--primary-text);
            font-size: 16px;
            font-weight: 500;
            line-height: 24px;
            transition: 0.3s ease-in-out all;
        }
    }

    .c-cart__line {
        position: relative;
        display: flex;
        align-items: flex-end;
    }

    .c-cart__icon {
        position: relative;
        display: flex;
        svg {
            transition: 0.3s ease-in-out all;
            fill: #262626;
        }
    }

    .c-cart__icon-number {
        position: absolute;
        top: -6px;
        right: -3px;
        @include box(16px);
        color: #fff;
        font-size: 11px;
        font-weight: 500;
        line-height: 16px;
        text-align: center;
        background-color: var(--danger);
        border-radius: 50%;
        opacity: 1;
        &.is-animated {
            animation: grow-shrink 0.35s ease 1;
        }
        &.is-active {
            opacity: 1;
        }
    }
</style>
